import axios from 'axios';

const getBaseURL = () => {
  try {
    const port = typeof window !== 'undefined' ? window.location.port : '';
    const isDev = process.env.NODE_ENV === 'development';
    if (isDev && port === '3000') return 'http://localhost:3001';
    return '';
  } catch {
    return '';
  }
};

const api = axios.create({
  baseURL: `${getBaseURL()}/api`
});

api.interceptors.request.use(
  (config) => {
    try {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch {}
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      try {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      } catch {}
      if (typeof window !== 'undefined') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
